const tours = {
  tour: "סיור", // translated
  tours: "סיורים", // translated
  addOn: "תוסיף", // translated
  addOns: "תוספות", // translated
  availableEscapes: "בריחה זמינה", // translated
  availableExperiences: "חוויות זמינות", // translated
  getRequest: "קבל בקשה", // translated
  sendRequest: "שלח בקשה", // translated
  selectRoom: "בחר חדר", // translated
};

export default tours;
